










import { Vue, Component } from 'vue-property-decorator';
import Datos from './DatosInstantenos.vue';

@Component({
  components: { Datos },
})
export default class DatosPantalla extends Vue {}
